import angular from 'angular';
import { formSubmit } from '@mode/legacy/data-access-model-js';

export const ApplicationController = function ($sce, $scope, $http, AccountModel, ModeCollection, $window) {
  var accountId = $('meta[name=current-username]').attr('content');
  if (accountId) {
    AccountModel.find({ username: accountId, useEntryPath: true, refresh: true }).then(function (account) {
      $scope.account = account;
    });
  }

  $scope.trust = function (html) {
    return $sce.trustAsHtml(html);
  };

  $scope.switchFilter = function (name, url) {
    $scope.activeFilter = name;

    $http({ method: 'PUT', url: url, data: { preference: { default_account: name } } });
  };

  $scope.toggleActivityMore = function ($event) {
    var target = angular.element($event.target);
    target.siblings('.hidden-action-items').toggleClass('visible');
    if (target.hasClass('more-items')) {
      target.siblings('.less-items').removeClass('hidden');
    } else {
      target.siblings('.more-items').removeClass('hidden');
    }
    target.addClass('hidden');
  };

  $scope.formSubmit = function (method, url) {
    formSubmit(url, {
      fields: {
        authenticity_token: $('meta[name=csrf-token]').attr('content'),
        _method: method,
      },
    });
  };

  $scope.intercomOpen = function (event, message, email) {
    // fallback to email if Intercom isn't loaded.
    if (typeof Intercom === 'undefined' || !Intercom.booted) {
      if (!event || !event.target || event.target.nodeName !== 'A') {
        event && event.preventDefault();
        // force page to given email unless mailto link is on element
        // If fallback email wasn't provided, default to help
        $window.location.assign('mailto:' + (email || 'help@modeanalytics.com') + '?subject=' + message);
      }
    } else {
      event && event.preventDefault();
      Intercom('showNewMessage', message);
    }
  };

  // simple helper function to send page to a url
  $scope.linkTo = function (url) {
    $window.location.href = encodeURI(url);
  };

  $scope.signUpSSOClicked = false;
  $scope.toggleSSOButtons = function ($event) {
    $event.preventDefault();
    $scope.signUpSSOClicked = !$scope.signUpSSOClicked;
  };

  $scope.updateForm = function (newPath) {
    var wrappedForm: any = angular.element(document.getElementsByTagName('form'));
    wrappedForm[0].action = newPath;
  };

  $scope.buttonText = 'Sign in';
  $scope.pwDisabled = false;
  $scope.ssoEnabledText = '';
  $scope.showIcon = false;
  $scope.showOptions = true;
  $scope.themedButton = {
    google: false,
    slack: false,
    o365: false,
    saml: false,
  };

  var initializePlanSelectionToggles = function () {
    const planDetailsDiv = angular.element('#plan-details');
    if (!planDetailsDiv) return;

    const showButton = angular.element('#show-btn');
    const hideButton = angular.element('#hide-btn');

    hideButton.hide();
    showButton.show();
    planDetailsDiv.hide();

    showButton.click(function () {
      planDetailsDiv.show();
      showButton.hide();
      hideButton.show();
    });

    hideButton.click(function () {
      planDetailsDiv.hide();
      showButton.show();
      hideButton.hide();
    });
  };
  initializePlanSelectionToggles();
};

ApplicationController.$inject = ['$sce', '$scope', '$http', 'AccountModel', 'ModeCollection', '$window'];
